import { useEffect } from 'react';

import { useStores } from '../stores/useStores';

export function useHiddenBodyOverflow(flag: boolean) {
  const { uiStore } = useStores();

  useEffect(() => {
    const k = Symbol('blocker');
    if (flag) {
      uiStore.setOverflowBlocker(k, true);
    } else {
      uiStore.setOverflowBlocker(k, false);
    }
    return () => {
      uiStore.setOverflowBlocker(k, false);
    };
  }, [uiStore, flag]);
}
